export default __webpack_public_path__ + "static/media/CreditCardMark.b0b8dcfd.svg";